import React from 'react';

export const ServerSideMemoContext = React.createContext<Record<string, unknown>>({});

export const DraftModeContext = React.createContext({
  draftMode: false,
});
